import './style.scss';

const BookingEventDetails = ({eventInfo, productType}) => {

    const eventData = eventInfo.slot || eventInfo.arrival || '';
    const isHideEventPlace = !eventInfo.slot?.hide_event_place && !eventInfo?.eventHideEventPlace;
    const toShortTime = time => time?.slice(0, -3);
    const toExtendedDateFormat = dateStr => {
        const date = new Date(dateStr);
        const options = {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
        }
        const formattedDate = date.toLocaleDateString("ru-RU", options);
        return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    }

    return (
        <div className="event-details">
            <>
                <div className="event-details__label event-details__label_time">
                    <div className="event-details__time">
                        {productType === 'slots' && eventData &&
                            <>{toShortTime(eventData?.start_time)}—{toShortTime(eventData?.end_time)}</>}
                    </div>
                    <div className="event-details__date">
                        {eventData && toExtendedDateFormat(eventData?.start_date)}
                    </div>
                </div>
                <div className="event-details__label event-details__label_location">
                    <div className="event-details__location">
                        {eventData?.name}
                    </div>
                    <div className="event-details__address">
                        {productType === 'slots' && isHideEventPlace &&
                            <>{eventInfo.base?.city}, {eventInfo.base?.street} {eventInfo.base?.house}</>}
                        {productType === 'arrivals' &&
                            eventData?.city}
                    </div>
                </div>
            </>
        </div>
    )
}

export default BookingEventDetails;